import { render, staticRenderFns } from "./doDiningList.vue?vue&type=template&id=588bff4d&scoped=true"
import script from "./doDiningList.vue?vue&type=script&lang=js"
export * from "./doDiningList.vue?vue&type=script&lang=js"
import style0 from "./doDiningList.vue?vue&type=style&index=0&id=588bff4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588bff4d",
  null
  
)

export default component.exports